import moment from 'moment'

/**
 * Add one day to end_date if it ends one day after
 */
export const computeValidEndDate = (shift, toDate: string) => {
  const isDayAfter = moment(shift.ends_at).isAfter(shift.starts_at, 'day')
  return isDayAfter ? moment(toDate).add(1, 'day') : toDate
}
